var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"process-item"},[_c('Header',{attrs:{"name":_vm.name,"color":_vm.headerColor}}),_c('div',{staticClass:"process-body-wrapper"},[_c('div',{staticClass:"process-body"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }